export default __webpack_public_path__ + "static/media/unchecked.c6679758.svg";